import checkout from "./form";

const {
	formField: { name, code, companyID },
} = checkout;

const initialValues = {
	[name.name]: "",
	[code.name]: "",
	[companyID.name]: null,
};

export default initialValues;
